<!--
 * @FileDescription: 账期管理-web
 * @Author: 陈文景
 * @Date: 2022-12-29 14:10:33
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <h3>{{$t('Billing.BillingStatement')}}</h3>

    <div class="content">
      <el-tabs v-model="active" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('Billing.Bills')" name="issued">
          <Issued ref="issued" />
        </el-tab-pane>
        <el-tab-pane :label="$t('Billing.IncomingBills')" name="unpublished">
          <Unpublished ref="unpublished" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Issued from './components/Issued.vue'
import Unpublished from './components/Unpublished.vue'

export default {
  components: {
    Issued,
    Unpublished
  },
  data() {
    return {
      active: 'issued'
    }
  },
  mounted() {
    this.$refs.issued.getIssuedBillsList()
  },
  methods: {
    /**
     * 切换Tab时触发的事件
     *
     * @param {Object} tab 当前切换的tab对象
     */
    handleClickTab(tab) {
      if (tab.name === 'issued') {
        this.$refs.issued.getIssuedBillsList()
        this.$refs.issued.doLayoutTable()
      }
      if (tab.name === 'unpublished') {
        this.$refs.unpublished.getUnpublishedBillsList()
        this.$refs.unpublished.doLayoutTable()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1228px;
  margin: 0 auto;

  h3 {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    margin: 8px 0;
  }

  .content {
    width: 100%;
    background-color: #fff;

    /deep/.el-tabs__nav-wrap {
      padding: 0 20px;
    }

    .el-tab-pane {
      padding: 0 20px;
      padding-bottom: 8px;
      height: calc(100vh - 150px);
    }
  }
}
</style>
